import { client, formatQueryParams } from 'util/sdk';

// eslint-disable-next-line import/prefer-default-export
export const load = ({ fspId, ...params }) =>
  client.fsps(fspId).importantMessages.query(formatQueryParams(params));
